export enum VideoType {
  INTRO = 0,
  OUTRO = 1,
  BACKGROUND = 2
}

export enum TiltAngle {
  NEGATIVE_5 = -5,
  NEGATIVE_3 = -3,
  CENTER = 0,
  POSITIVE_3 = 3,
  POSITIVE_5 = 5
}

export enum ScaleFactor {
  SCALE_DOWN = 0.9,
  SCALE_UP = 1.2
}

export enum MovementBundle {
  DEFAULT = 1,
  BASIC = 2,
  ZOOM = 3,
  LEFT_RIGHT = 4
}

export enum OpacityLevel {
  TRANSPARENT = 0,
  OPAQUE = 1
}

export enum OpenShotTransformation {
  MUTE_AUDIO = 0,
  FADE_IN_AND_OUT = 1,
  FADE_IN = 2,
  FADE_OUT = 3,
  SIMPLE_SCALE = 4,
  HIDE_IMAGE = 5,
  ADD_BARS = 6,
  ADD_BLUR = 7,
  SCALE_IMAGE_EFFECT = 8,
  MOVE_IMAGE_EFFECT = 9,
  FADE_IN_AND_OUT_IMAGE_EFFECT = 10,
  FADE_IN_IMAGE_EFFECT = 11,
  FADE_OUT_IMAGE_EFFECT = 12,
  SIMPLE_SCALE_IMAGE_EFFECT = 13
}
